import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {bindFunctionsToThis} from '../../extensions';

@Component({
  selector: 'ig-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonComponent {
  public isLoading: boolean;
  @Input() public icon: string;
  @Input() public disabled: boolean;
  @Input() public iconAtLeft: boolean;
  @Input() public size: 'lg' | 'md' = 'md';
  @Input() public passClickEvent: boolean;
  @Input() public isAsync: boolean;
  @Input() public color: 'primary' | 'accent' | 'cancel' | 'warn' | 'transparent' = 'primary';
  @Output() public trigger = new EventEmitter<ButtonTriggerEvent>();

  constructor() {
    bindFunctionsToThis(this);
  }

  public onClick($event: Event) {
    if (this.passClickEvent) {
      return;
    }

    $event.preventDefault();
    $event.stopPropagation();

    let triggerEvent: ButtonTriggerEvent = {
      complete: this.complete,
      immediateComplete: this.immediateComplete,
      stop: this.complete,
      start: this.load
    };

    if (this.isAsync) {
      this.load();
    }

    this.trigger.emit(triggerEvent);
  }

  private load() {
    this.isLoading = true;
  }

  private complete() {
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

  private immediateComplete() {
    this.isLoading = false;
  }
}

export class ButtonTriggerEvent {
  complete: () => void;
  immediateComplete: () => void;
  stop: () => void;
  start: () => void;
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/button/button.component.ts